<template>
  <div class="user">
    <div class="photo">
      <img :src="this.$store.user_picture" id="avatarImg" alt="avatar" />
    </div>
    <div class="user-info">
      <a>
        <span v-if="$route.meta.rtlActive">
          {{ rtlTitle }}
        </span>
        <span v-else>
          {{ title }}
        </span>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    rtlTitle: {
      type: String,
      default: "تانيا أندرو"
    }
  },
  data() {
    return {
      isClosed: true,
      title: this.$store.first_name + " " + this.$store.last_name
    };
  },
  methods: {
    getImage() {
      if (
        this.$store.user_picture == null ||
        this.$store.user_picture === "null"
      ) {
        this.$store
          .me()
          .then(response => {
            if (response.data.picture) {
              this.$store.user_picture = response.data.picture;
            } else {
              this.$store.user_picture = "/img/default-avatar.png";
            }
          })
          .catch(error => {
            this.$store.user_picture = "/img/default-avatar.png";
          });
      }
    },

    clicked: function(e) {
      e.preventDefault();
    }
  },
  mounted() {
    this.getImage();
  }
};
</script>
